import React from 'react';
import { connect } from 'react-redux';
import { Translate } from 'react-localize-redux';
import { withLocalize } from "react-localize-redux";
import AmlCandidate from './amlCandidate';
import OldStyleTableWithHistory from '../../common/oldStyleTableWithHistory';

class AmlEntityData extends React.Component {

    render() {
        const data = this.props.isOnPath ? this.props.candidates : this.props.candidates.filter(candidate => this.props.sections[this.props.section].newLimit <= candidate.confidenceRate || 
            this.props.sections[this.props.section].isExpanded);

        return (
            <OldStyleTableWithHistory tableColumns={3} stripped
                head={() => this.renderHead()}
                actualData={data}
                actualRow={(r, idx) => <AmlCandidate 
                    key={idx} 
                    candidate={r} 
                    hasBirthDate={this.props.hasBirthDate} 
                    isOnPath={this.props.isOnPath} 
                    />}
            />
        );
    }

    renderHead = () => {
        return (
            <thead>
                <tr>
                    <th><Translate id="Report.Aml.Subjects.Candidate" /></th>
                    <th style={{ textAlign: "right" }}><Translate id="Report.Aml.Subjects.PercentOfConfidence" /></th>
                    <th><Translate id="Report.Aml.Subjects.DateOfBirth" /></th>
                    <th><Translate id="Report.Aml.Subjects.PlaceOfBirth" /></th>
                    <th><Translate id="Report.Aml.Subjects.Source" /></th>
                    <th>&nbsp;</th>
                </tr>
            </thead>
        );
    }
}

export default withLocalize(connect(state => state.amlCandidates)(AmlEntityData));